// ABOUTME: Portal-above-chrome wrapper (SPEC-26 D6) — renders reel overlay content into document.body
// ABOUTME: above the existing z-order (Projectionist 20 < CavalryViz 55 < footer/mic pill 60).

import { createPortal } from 'react-dom';

// Above the footer/mic pill (z-[60]) — the highest existing layer — so the point-tag layer and
// the split CC pair sit on top of all current chrome, per D6's "portal-above-chrome" decision.
// Exact stacking relative to individual chrome elements is a Phase 3/4 styling concern; this
// default is the unstyled-shell placement for Phase 2.
const DEFAULT_Z_INDEX = 65;

/**
 * @param {{ children: React.ReactNode, zIndex?: number, hidden?: boolean }} props `hidden` (SPEC-82 Rev 3): the layer stays mounted
 *   (tag dwell, the sheet's own state survive) but is invisible and inert; omitted/false renders exactly as before
 */
function OverlayPortal({ children, zIndex = DEFAULT_Z_INDEX, hidden = false }) {
  const style = { position: 'fixed', inset: 0, zIndex, pointerEvents: 'none' };
  return createPortal(
    hidden ? <div style={{ ...style, opacity: 0 }} inert>{children}</div> : <div style={style}>{children}</div>,
    document.body,
  );
}

export default OverlayPortal;
